import CountryOption from "./CountryOption";
import compose from "recompose/compose";
import withProps from "recompose/withProps";
import withHandlers from "recompose/withHandlers";
import withQueryParams from "../../../hocs/withQueryParams";
import { localiseUrlII } from "src/common/utils/format-localised-url";
import { withModel } from "../../../data-providers/model";
import { getCountryWithIsoAndContentLocale } from "src/common/l10n/country";
import { getRedirectUrl } from "src/common/utils/get-redirect-url";
import { navigate } from "src/common/utils/navigate";
import isParamAbsoluteURL from "src/common/utils/is-param-absolute-url";

const enhance = compose(
  withModel,
  withQueryParams,
  withProps((props) => {
    const countryModel = getCountryWithIsoAndContentLocale(
      props.iso,
      props.locale
    );
    return {
      countryModel,
      route: localiseUrlII(countryModel, "/"),
    };
  }),
  withHandlers((props) => {
    const returnToUID = props.queryParams.return_to_uid;
    let isAbsoluteUrl = isParamAbsoluteURL(returnToUID);

    return {
      handleOnClick: (props) => (e) => {
        e.preventDefault();
        let route = props.route;

        // If the uid is real then set the route to the correct path
        if (!isAbsoluteUrl && returnToUID) {
          route = getRedirectUrl(
            returnToUID,
            props.countryModel,
            props.model.prismicPageRedirectLanguages
          );
        }

        // Navigate to the correct route and track the event
        navigate(route, props.queryParams, {
          action: "Change country from country page",
          from: props.model.countryModel.prefix,
          to: props.countryModel.prefix,
        });
      },
    };
  })
);

export default enhance(CountryOption);
